module.exports = __webpack_public_path__ + "img/apoio-faculdad-del-ciencia.46633318.png";